import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {AksjeklasseModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";

const debug = initDebugger('AntallAksjerPerAksjeklasseKomponent');

@Component({
    selector: 'antall-aksjer-per-aksjeklasse',
    templateUrl: './antall-aksjer-per-aksjeklasse.html',
    styleUrls: ['./antall-aksjer-per-aksjeklasse.scss'],
    changeDetection: ChangeDetectionStrategy.Default
})
export class AntallAksjerPerAksjeklasseKomponent {

    aksjeklassserMedAntallSortert: { klasse: AksjeklasseModell; navn: string, antall: number }[] = [];

    @Input({required: true}) set aksjeklasserMedAntall(aksjeklassserMedAntall: Map<AksjeklasseModell, number>) {
        this.aksjeklassserMedAntallSortert = [...aksjeklassserMedAntall.keys()]
          .sort((a, b) => a.navn.localeCompare(b.navn))
          .map(klasse => ({klasse, navn: klasse.navn, antall: aksjeklassserMedAntall.get(klasse) as number}))
          .filter(innslag => innslag.antall > 0);
    }

}
